import { useState } from "react";
import { Folder, Tag, ChevronRight } from "lucide-react";

// Build a flat ordered list with depth metadata — avoids recursive JSX that breaks Babel plugin
function buildFlatTree(allCats, parentSlug, depth, openSet) {
  const children = allCats.filter(c => (c.parent_slug || "") === parentSlug);
  const rows = [];
  children.forEach(cat => {
    rows.push({ cat, depth });
    const hasChildren = allCats.some(c => (c.parent_slug || "") === cat.slug);
    if (hasChildren && openSet.has(cat.slug)) {
      const nested = buildFlatTree(allCats, cat.slug, depth + 1, openSet);
      nested.forEach(r => rows.push(r));
    }
  });
  return rows;
}

export default function CategoryTreeNode({ allCats, selectedSlug, onSelect }) {
  // Track which nodes are expanded
  const topLevelSlugs = allCats
    .filter(c => !c.parent_slug)
    .map(c => c.slug);
  const [openSet, setOpenSet] = useState(new Set(topLevelSlugs));

  const toggleOpen = (slug) => {
    setOpenSet(prev => {
      const next = new Set(prev);
      if (next.has(slug)) next.delete(slug);
      else next.add(slug);
      return next;
    });
  };

  const rows = buildFlatTree(allCats, "", 0, openSet);

  return (
    <div>
      {rows.map(({ cat, depth }) => {
        const hasChildren = allCats.some(c => (c.parent_slug || "") === cat.slug);
        const isSelected = selectedSlug === cat.slug;
        const isOpen = openSet.has(cat.slug);

        return (
          <button
            key={cat.slug}
            onClick={() => {
              onSelect(cat);
              if (hasChildren) toggleOpen(cat.slug);
            }}
            style={{ paddingLeft: 12 + depth * 14 }}
            className={`flex items-center gap-2 w-full text-left px-3 py-2 rounded-lg text-xs transition-all ${
              isSelected ? "bg-orange-50 text-orange-600 font-semibold" : "text-slate-700 hover:bg-slate-50"
            }`}
          >
            {hasChildren
              ? <Folder className="w-3.5 h-3.5 flex-shrink-0" />
              : <Tag className="w-3.5 h-3.5 flex-shrink-0 text-slate-400" />
            }
            <span className="truncate flex-1">{cat.name || cat.title}</span>
            {cat.product_count > 0 && (
              <span className="text-[10px] bg-slate-100 text-slate-500 rounded px-1">{cat.product_count}</span>
            )}
            {hasChildren && (
              <ChevronRight className={`w-3 h-3 flex-shrink-0 transition-transform ${isOpen ? "rotate-90" : ""}`} />
            )}
          </button>
        );
      })}
    </div>
  );
}
